import React, {useEffect, useState} from 'react';
import Layout from "./Layout";
import config from '../config';
import axios from 'axios';
import { Link } from 'react-router-dom';
import BannerImage from '../assets/images/contact-page-bg.jpg';
import BannerMobileImage from '../assets/images/contact-page-bg.jpg';
export default function Contact() {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [isMailSent, setIsMailSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Handle form submission logic here

        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/send-email`, formData, { withCredentials: true });
            if(response){
                setIsMailSent(true);

                setFormData({
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    message: '',
                });
            }

            setTimeout(() => {
                setIsMailSent(false);
            }, 5000);
        } catch (error) {
            console.error("Error fetching blogs:", error);
            setIsMailSent(false);
        }
    };

  return (
    <>
    <Layout>
        <div className='contact-page position-relative'>  
            <picture>
                <source media="(max-width: 645px)" srcSet={BannerMobileImage} />
                <img src={BannerImage} alt="Logo" className='position-absolute' />
            </picture>      
            <div className='container position-relative'>
                <div className='contact-page-inner d-flex'>
                    <div className='contact-page-left'>
                        <h1 className='text-whiite' data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">Contact</h1>
                        <form onSubmit={handleSubmit} data-aos="fade-up" data-aos-delay="600" data-aos-duration="1000" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">
                            <div className='form-group'>
                                <input
                                    type="text"
                                    name="first_name"
                                    className="form-field"
                                    placeholder="your name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className='form-group'>
                                <input
                                    type="text"
                                    name="last_name"
                                    className="form-field"
                                    placeholder="last name"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className='form-group'>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-field"
                                    placeholder="your email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className='form-group '>
                                <input
                                    type="tel"
                                    name="phone"
                                    className="form-field"
                                    placeholder="your phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className='form-group full-width'>
                                <textarea
                                    name="message"
                                    className="form-field"
                                    placeholder="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='form-group full-width'>
                                {isMailSent && (<><p style={{color: "#fff"}}>Message Sent!</p></>)}
                                <div className='contact-form-button'>
                                    <button type="submit" className='form-submit'>SEND 
                                        <svg width="17" height="5" viewBox="0 0 17 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.0207 2.67678C16.1183 2.57915 16.1183 2.42085 16.0207 2.32322L14.4297 0.732233C14.3321 0.634602 14.1738 0.634602 14.0762 0.732233C13.9785 0.829864 13.9785 0.988155 14.0762 1.08579L15.4904 2.5L14.0762 3.91421C13.9785 4.01184 13.9785 4.17014 14.0762 4.26777C14.1738 4.3654 14.3321 4.3654 14.4297 4.26777L16.0207 2.67678ZM0 2.75L15.8439 2.75V2.25L0 2.25L0 2.75Z" fill="white"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className='contact-page-right'>
                        <div data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">
                            <h4>General Enquiries</h4>
                            <a href="mailto:info@littlecoveespresso.com">info@littlecoveespresso.com</a>
                            <ul className='social-icons d-flex'>
                                <li>
                                    <Link to="https://www.instagram.com/littlecove.espresso/?hl=en" target="_blank">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.0039 5.50781C7.51953 5.50781 5.51562 7.51172 5.51562 9.99609C5.51562 12.4805 7.51953 14.4844 10.0039 14.4844C12.4883 14.4844 14.4922 12.4805 14.4922 9.99609C14.4922 7.51172 12.4883 5.50781 10.0039 5.50781ZM10.0039 12.9141C8.39844 12.9141 7.08594 11.6055 7.08594 9.99609C7.08594 8.38672 8.39453 7.07812 10.0039 7.07812C11.6133 7.07812 12.9219 8.38672 12.9219 9.99609C12.9219 11.6055 11.6094 12.9141 10.0039 12.9141ZM15.7227 5.32422C15.7227 5.90625 15.2539 6.37109 14.6758 6.37109C14.0938 6.37109 13.6289 5.90234 13.6289 5.32422C13.6289 4.74609 14.0977 4.27734 14.6758 4.27734C15.2539 4.27734 15.7227 4.74609 15.7227 5.32422ZM18.6953 6.38672C18.6289 4.98438 18.3086 3.74219 17.2812 2.71875C16.2578 1.69531 15.0156 1.375 13.6133 1.30469C12.168 1.22266 7.83594 1.22266 6.39062 1.30469C4.99219 1.37109 3.75 1.69141 2.72266 2.71484C1.69531 3.73828 1.37891 4.98047 1.30859 6.38281C1.22656 7.82812 1.22656 12.1602 1.30859 13.6055C1.375 15.0078 1.69531 16.25 2.72266 17.2734C3.75 18.2969 4.98828 18.6172 6.39062 18.6875C7.83594 18.7695 12.168 18.7695 13.6133 18.6875C15.0156 18.6211 16.2578 18.3008 17.2812 17.2734C18.3047 16.25 18.625 15.0078 18.6953 13.6055C18.7773 12.1602 18.7773 7.83203 18.6953 6.38672ZM16.8281 15.1562C16.5234 15.9219 15.9336 16.5117 15.1641 16.8203C14.0117 17.2773 11.2773 17.1719 10.0039 17.1719C8.73047 17.1719 5.99219 17.2734 4.84375 16.8203C4.07812 16.5156 3.48828 15.9258 3.17969 15.1562C2.72266 14.0039 2.82813 11.2695 2.82813 9.99609C2.82813 8.72266 2.72656 5.98438 3.17969 4.83594C3.48438 4.07031 4.07422 3.48047 4.84375 3.17187C5.99609 2.71484 8.73047 2.82031 10.0039 2.82031C11.2773 2.82031 14.0156 2.71875 15.1641 3.17187C15.9297 3.47656 16.5195 4.06641 16.8281 4.83594C17.2852 5.98828 17.1797 8.72266 17.1797 9.99609C17.1797 11.2695 17.2852 14.0078 16.8281 15.1562Z" fill="white"/>
                                        </svg>
                                    </Link>
                                </li>
                                {/* <li>
                                    <Link to="/">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1112_136)">
                                            <path d="M17.7188 9C17.7188 4.18359 13.8164 0.28125 9 0.28125C4.18359 0.28125 0.28125 4.18359 0.28125 9C0.28125 13.3516 3.46957 16.9587 7.6377 17.6133V11.5204H5.42285V9H7.6377V7.07906C7.6377 4.8941 8.93848 3.68719 10.9308 3.68719C11.8849 3.68719 12.8827 3.85734 12.8827 3.85734V6.00187H11.783C10.7002 6.00187 10.3623 6.67406 10.3623 7.36348V9H12.7804L12.3936 11.5204H10.3623V17.6133C14.5304 16.9587 17.7188 13.3516 17.7188 9Z" fill="white"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_1112_136">
                                            <rect width="18" height="18" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                    </Link>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>                
            </div>
        </div>    
    </Layout>
      
    </>
  )
}
